import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {scopedState}    from "@Common/react/scoped-state";
import {scnv}           from "@Common/react/state-change-nested-value";
import {UseState}       from "@Common/react/use-state";

import {MetaShareTargetBox} from "./meta-share-target-box";

export const MetaTarget = ({shareFb, shareIg, isPlatformSelectedInitially, next}) => cs(
    consumeContext("apis"),
    consumeContext("socialMediaStatus"),
    ["account", ({apis, socialMediaStatus}, next) => Load2({
        _key: socialMediaStatus?.facebook,
        fetch: () => socialMediaStatus?.facebook && apis.next.social.getFbSocial(),
        next,
    })],

    ["unselected", ({socialMediaStatus}, next) => UseState({initValue: isPlatformSelectedInitially?.(socialMediaStatus?.['instagram'] ? "meta" : "facebook")===false, next})],
    ["unselectedPages", (_, next) => UseState({next})],
    ["fbUnselected", (_, next) => UseState({initValue: isPlatformSelectedInitially?.("facebook")===false, next})],
    ["igUnselected", (_, next) => UseState({initValue: isPlatformSelectedInitially?.("instagram")===false, next})],
    ({account, unselectedPages, unselected, fbUnselected, igUnselected, socialMediaStatus, apis}) => {

        const isFbPagesValid = account.value?.data?.fb_pages.constructor === Array;

        const sharablePages = !account.value?.action && isFbPagesValid ? [] : (
            isFbPagesValid && account.value.data.fb_pages.filter((page) => !unselectedPages.value || !unselectedPages.value[page.id])
        );

        const igAvailable = socialMediaStatus?.['instagram'];

        return next(!!account.value && {
            key: !igAvailable ? "facebook" : "meta",
            displayName: !igAvailable ? "facebook" : "meta",
            unselected: account.value.action && unselected.value,
            getUnselectedPlatforms: () => (
                !account.value.action ? (
                    []
                ) : !igAvailable ? (
                    unselected.value ? ["facebook"] : []
                ) : (
                    [
                        unselected.value && "meta",
                        fbUnselected.value && "facebook",
                        igUnselected.value && "instagram",
                    ].filter(v=>v)
                )
            ),
            render: ({isShared=undefined}) => MetaShareTargetBox({
                igAvailable,
                login_url: account.value.login_url ?? account.value.data?.fb_account?.login_url,
                account: account.value.action && {
                    ...account.value.data.fb_account,
                    edit: isFbPagesValid && account.value.data.fb_account && (async () => {
                        await apis.next.social.removeFbSocial();
                        window.location = account.value.data.fb_account?.login_url
                    }),
                    pages: isFbPagesValid && account.value.data.fb_pages.map((page) => ({
                        ...page,
                        unselectedPage: scopedState(unselectedPages, [page.id]),
                    })),
                    ig_account: account.value.data.ig_account,
                },
                onRemoveAccount: async () => {
                    await apis.next.social.removeFbSocial();
                    scnv(  account, ["action"], () => false );
                },
                isShared,
                unselected,
                fbUnselected,
                igUnselected,
            }),

            sharable: sharablePages.length && !unselected.value,

            getSharePieces: () => [
                // Share to FB
                ...!fbUnselected.value && sharablePages.map((page) => ({
                    id: page.id,
                    type: "facebook",

                    invokeShare: (params) => shareFb({
                        ...params,
                        account: account.value, page,
                    }),
                })) || [],

                // Share to IG
                ...!igUnselected.value && igAvailable && account.value.data.ig_account && [{
                    id: account.value.data.fb_account.id,
                    type: "instagram",
                    invokeShare: shareIg,
                }] ||[],
            ],
        });
    },
);
